import styled from 'styled-components'
import ButtonStyle from '@material-ui/core/Button'
import { FlexContainer } from '../../../styled'
import ListItem from '../listItem'

export const Button = styled(ButtonStyle)`
  && {
    min-width: 33px;
    margin-right: 10px;

    svg {
      & + span {
        display: none;
      }
    }

    &:hover {
      svg {
        margin-right: 6px;

        & + span {
          display: block;
        }
      }
    }
  }
`


export const MenuOption = styled.ul`
  position: absolute;
  width: 100%;
  min-width: 212px;
  margin-top: 49px;
  overflow: hidden;
  height: fit-content;
  background-color: ${({ theme }) => theme.container.secondary.background};
  display: flex;
  flex-flow: column;
  z-index: 2;
  box-shadow: -2px 5px 20px -5px rgba(72, 69, 77, 0.2);
  border-radius: 3px;
  &.hidden {
    display: none;
  }
  >li.dashboard {
	padding: 0;
	font-size: 14px;
	&.active {
	  background-color: #f5f5f5;
	}
	a {
	  text-decoration: none;
      color: #6B6871;
	  padding: 8px 14px;
	  width: 100%;
	}
  }
`

export const Container = styled(FlexContainer)`
  position: relative;

  >li {
    padding: 10px 16px!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
	&.open {
	  p+svg {
		transform: rotate(180deg);
	  }
	}
    svg {
      height: 16px;
      margin-right: 10px;
      color: inherit;
      width: auto;
    }

    p {
      color: inherit;
      white-space: nowrap;
      font-size: 0.75rem;
      & + svg {
        margin-left: 10px;
        margin-right: 0;
        height: 6px!important;
      }
    }
  }
`